import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc7ce66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex"} }

import {onMounted, ref} from "vue";
import axios from "axios";

import request from "@/api/index.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'verificationCode',
  setup(__props, { expose: __expose }) {

let verCode = ref("");
let answerCode = "";
let verImg = ref("");
function getCode() {
  request.get("user/captcha").then(
      res => {
         console.log(res);
        console.log(res.data.data.code);
        if (res.status === 200) {
          verImg.value = "data:image/png;base64," + res.data.data.base64;
          answerCode = res.data.data.code;
        } else
          console.log("get captcha error");
      }
  ).catch(err => {
    console.log(err);
    console.log("captcha error");
  });
  // console.log("获取验证码后访问验证码session" + JSON.parse(sessionStorage.getItem("captcha")));
  // axios.get("/api/user/captcha", {headers: {"Content-Type": "application/json,charset=utf-8"}})
  //     .then((res) => {
  //       // console.log(answerCode);
  //       // console.log(res);
  //       if (res.statusText === "OK") {
  //         verImg.value = "data:image/png;base64," + res.data.data.base64;
  //         answerCode = res.data.data.code;
  //       } else
  //         console.log("get captcha error");
  //     }).catch((err) => {
  //   console.log(err);
  //   console.log("captcha error");
  // });
}

const verificateFlag = () => {
  // console.log(verCode.value);
  //verCode.value=answerCode
  console.log("verCode.value: ", verCode.value);
  console.log("answerCode: ", answerCode);
  return verCode.value === answerCode;
};

__expose({
  verificateFlag,
  getCode,
  verCode
});

onMounted(getCode);


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, {
      modelValue: _unref(verCode),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(verCode) ? (verCode).value = $event : verCode = $event)),
      clearable: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_image, {
      src: _unref(verImg),
      onClick: getCode
    }, null, 8, ["src"])
  ]))
}
}

})